import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface SeoData {
  title?: any;
  description?: any;
  keywords?: any;
  siteurl?: any;
  imageurl?: any;
}

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  // This part is happended at the end of head>title
  private siteTitle = 'EIM SOLUTIONS';

  constructor(private _title: Title, private _meta: Meta) {}

  public setHeaders(data: SeoData) {
    this._title.setTitle([data.title, this.siteTitle].join(' | '));
    this._meta.updateTag({
        content: data.description,
        name: 'description'
      },
    );
    this._meta.updateTag({
        content: data.title,
        name: 'og:title'
      },
    );
    this._meta.updateTag({
        content: data.description,
        name: 'og:description'
      },
    );
    this._meta.updateTag({
        content: data.imageurl,
        name: 'og:image'
      },
    );

    this._meta.updateTag({
        content: data.keywords,
        name: 'keywords'
      },
    );

    this._meta.updateTag({
        content: data.siteurl,
        name: 'og:url'
      },
    );
  }
}